import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useDispatch, useSelector } from "react-redux";
import { toastAlert } from "../../lib/toastAlert";
import { Link } from 'react-router-dom';
import Web3 from 'web3';
import { SaveCustomToken } from '../../actions/users';
import Loader from '../../assets/images/uploadimg.png'
import config from "../../lib/config"
import { network } from "../AdminNetwork";
import TokenAbi from "../../ABI/Token.json";
import Trade from "../../ABI/market.json";
import TrafeFraction from "../../ABI/FractionTrade.json"
import {wallet_connect_context} from "../../actions/redux/action";
import { useNavigate } from 'react-router-dom';


const initialFormValue = {
    'name': "",
    'name1': "",
}

const AddToken = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const Wallet_Details = useSelector((state) => state.admin);
    const [formValue, setFormValue] = useState(initialFormValue);
    const [UserAccountAddr, Set_UserAccountAddr] = useState('')
    const [Accounts, Set_Accounts] = useState('')

    const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } }
        setFormValue(formData)
    }

  const {
    name ,name1
  } = formValue

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (Wallet_Details.UserAccountAddr) {
            let web3 = new Web3(window.ethereum);
            let chain1 = await web3.eth.getChainId();
            let chain = parseInt(chain1)
            const ABI = Trade;

            try {
                    var Contract = await new web3.eth.Contract(ABI, Wallet_Details.networkConfiguration.TradeFractionContract);
                        const CurrNetwork = chain == config.ETH ? network.ETH : network.MATIC;
                        const TradeContract = new web3.eth.Contract(TrafeFraction, Wallet_Details.networkConfiguration.FractionTradeContract);

                        if (TradeContract) {
                            try {
                                try{
                                const AddtokenTradeCon = await TradeContract.methods.setCollectionAddress(name,name1).send({ from: Wallet_Details.UserAccountAddr });
                                if (AddtokenTradeCon) {
                                    toastAlert("success", 'Success');
                                } else {
                                    toastAlert("error", "TryIt Again Later.Failed To Add Token");
                                }
                            }catch(err){
                                console.log("asdadwqeqweqw",err);
                            }
                            } catch (error) {
                                console.log("Error during contract interaction:", error);
                                toastAlert("error", "Failed to check or add token to the contract");
                            }
                        }
                    
                
            } catch (error) {
                console.log("Error:", error);
                toastAlert("error", "Not an ERC20 token address & check the Connected Network");
            }
        } else {
            toastAlert("error", "Connect Your Wallet");
        }
    };

    const handleFormSubmit1 = async (e) => {
        e.preventDefault();
        if (Wallet_Details.UserAccountAddr) {
            let web3 = new Web3(window.ethereum);
            let chain1 = await web3.eth.getChainId();
            let chain = parseInt(chain1)
            const ABI = Trade;

            try {
                    var Contract = await new web3.eth.Contract(ABI, Wallet_Details.networkConfiguration.TradeFractionContract);
                        const CurrNetwork = chain == config.ETH ? network.ETH : network.MATIC;
                        const TradeContract = new web3.eth.Contract(TrafeFraction, Wallet_Details.networkConfiguration.FractionTradeContract);
                        if (TradeContract) {
                            try {
                                try{
                                const AddtokenTradeCon = await TradeContract.methods.transferOwnership(name).send({ from: Wallet_Details.UserAccountAddr });
                                if (AddtokenTradeCon) {
                                    toastAlert("success", 'Success');
                                } else {
                                    toastAlert("error", "TryIt Again Later.Failed To Add Token");
                                }
                            }catch(err){
                                console.log("asdadwqeqweqw",err);
                            }
                            } catch (error) {
                                console.log("Error during contract interaction:", error);
                                toastAlert("error", "Failed to check or add token to the contract");
                            }
                        }
                    
                
            } catch (error) {
                console.log("Error:", error);
                toastAlert("error", "Not an ERC20 token address & check the Connected Network");
            }
        } else {
            toastAlert("error", "Connect Your Wallet");
        }
    };

    const chainIdCheck = async (configchainid) => {
        var Config = {};
    
        if (configchainid === network.MATIC.Chainid) {
            Config = network.MATIC;
        } else if (configchainid === network.ETH.Chainid) {
            Config = network.ETH;
        } else if (configchainid === network.CAM.Chainid) {
          Config = network.CAM;
        }
        const hexString = configchainid && configchainid.toString(16);
        if (window.ethereum) {
            try {
                // check if the chain to connect to is installed
    
                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
                });
                return true;
            } catch (error) {
                // This error code indicates that the chain has not been added to MetaMask
                // if it is not, then install it into the user MetaMask
                if (error.code === 4902) {
                    try {
                        await window.ethereum.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                {
                                    chainId: "0x" + hexString,
                                    rpcUrl: Config.RPC_URL,
                                },
                            ],
                        });
                        return true;
                    } catch (addError) {
                        console.log("err in nested catch", addError);
                        console.error(addError);
                    }
                }
                console.error(error);
            }
        } else {
            // if no window.ethereum then MetaMask is not installed
            //console('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html');
            return false;
        }
    };

    async function SwitchNetwork() {
        var web3;
        try {
            if (window.ethereum) {
                web3 = new Web3(window.ethereum);
                if (window.ethereum.isMetaMask == true) {
                    const chainId1 = await web3.eth.getChainId();
                    const chainId = parseInt(chainId1)
                    var configchainid =
                        chainId === network.ETH.Chainid
                            ? network.MATIC.Chainid 
                            : chainId === network.MATIC.Chainid ? network.CAM.Chainid : network.ETH.Chainid;
                    if (parseInt(chainId) != parseInt(configchainid)) {
                        chainIdCheck(configchainid);
                        return web3;
                    }
                } else {
                    alert("Please Uninstall CoinbaseWallet or Connect to Coinbase");
                    return false;
                }
            } else {
            }
        } catch (e) { }
        console.log("web3................................", web3);
        return web3;
    }

    const changeNetwork = async () => {
        if (window.ethereum.isMetaMask == true) {
            var web3 = new Web3(window.ethereum);
            var networkConfiguration = "";
            var web3Obj = await SwitchNetwork();    
            const accounts1 = await web3Obj.eth.getAccounts();
            const accounts = accounts1[0]
    
            if (accounts != "") {
                const IDcheck = await web3.eth.getChainId();
    
                if (IDcheck === network.MATIC.Chainid) {
                    networkConfiguration = network.MATIC;
                } else if (IDcheck === network.ETH.Chainid) {
                    networkConfiguration = network.ETH;
                }else if (IDcheck === network.CAM.Chainid) {
                  networkConfiguration = network.CAM;
              }
                dispatch(wallet_connect_context({
                    UserAccountAddr: accounts,
                    WalletConnected: "true",
                    Accounts: accounts,
                    providerss: web3Obj._provider,
                    networkConfiguration: networkConfiguration,
                }));
            }
        }
    };

    const getConnect = async () => {
        try {
            var configdata = {};
            if (window.ethereum) {
                var web3 = new Web3(window.ethereum);
                if (web3 !== undefined) {
                    await window.ethereum.enable().then(async function () {
                        const web3 = new Web3(window.web3.currentProvider);
                        if (window.web3.currentProvider.networkVersion === config.ETH_ID) {
                            var currentChainId = network.ETH.Chainid;
                            configdata = network.ETH;
                        } else if (window.web3.currentProvider.networkVersion === config.MATIC_ID) {
                            var currentChainId = network.MATIC.Chainid;
                            configdata = network.MATIC;
                        }
                        else if (window.web3.currentProvider.networkVersion === config.CAM_ID) {
                          var currentChainId = network.CAM.Chainid;
                          configdata = network.CAM;
                      }
                        if (window.web3.currentProvider.networkVersion == currentChainId) {
                            if (window.web3.currentProvider.isMetaMask === true) {
                                var currAddr1 = await web3.eth.getAccounts();
                                var currAddr = currAddr1[0].toLowerCase();
                                if (
                                    window.web3 && currAddr
                                ) {
                                    
                                    var CurAddr = String(currAddr).toLowerCase();
                                    Set_UserAccountAddr(CurAddr);
                                    var result = await web3.eth.getAccounts();
                                    var setacc = result[0];
                                    Set_Accounts(setacc);
    
                                    dispatch(wallet_connect_context({
                                        UserAccountAddr: setacc,
                                        WalletConnected: "true",
                                        Accounts: setacc,
                                        providerss: web3._provider,
                                        networkConfiguration: configdata,
                                    }));
                                }
                            }
                        } else {
                            toastAlert("update", "Please Connect Wallet");
                        }
                    });
                }
            }
        } catch (errr) {
            console.log("get connect", errr);
        }
    };

    const disconnect = () => {
        Set_Accounts('')
    }

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Add Tokens'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                        

                            <div>
                                <div className='d-sm-flex gap-2'>
                            <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>
                                <button className="btn addcate con" onClick={() => Accounts == '' ? getConnect() : disconnect()}><Link to="#">{Accounts != "" ? Accounts : "Connect"}</Link></button>
                                </div>
                              
                                <div>
                                    <div>
                                        <div>
                                            <form noValidate onSubmit={handleFormSubmit} autoComplete="off">
                                                <div color="primary" className="addcategorys">
                                                    <h4>Add Tokens</h4>
                                                </div>
                                                <div className="categorylisdt">
                                                <div className='row'>
                                                <div className='col-xl-7 mt-3'>
                                                            <label htmlFor="name">Deployer</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                id="name"
                                                                onChange={onChange}
                                                                value={name}
                                                                fullWidth
                                                            />
                                                     
                                                        </div>
                                                        <div className='col-xl-7 mt-3'>
                                                            <label htmlFor="name">fraction 721</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                id="name1"
                                                                onChange={onChange}
                                                                value={name1}
                                                                fullWidth
                                                            />
                                                     
                                                        </div>
                                                        <div style={{ marginTop: 20 }}>
                                                            <button type="button" className="btn addcate" onClick={changeNetwork}>
                                                                Switch Network
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <button color="primary" type="submit" className="btn addcate mt-4">Add</button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

    
        </>
    )
}

export default AddToken